<template>
  <div
    :class="{
      'main-bottom-multiselect-container-without-ex': !expandToRight,
      'main-bottom-multiselect-container':
        expandToRight &&
        sector !== 'sms' &&
        sector !== 'bad_number' &&
        sector !== 'not_interested',
      'main-bottom-multiselect-container-sms':
        expandToRight && sector === 'sms',
      'main-bottom-multiselect-container-bad_number':
        expandToRight && sector === 'bad_number',
      'main-bottom-multiselect-container-rank':
        sector === 'assignments' &&
        (selectedTab === 'rank_1' ||
          selectedTab === 'rank_2' ||
          selectedTab === 'rank_3' ||
          selectedTab === 'assigned_rankings')
    }"
  >
    <!--    :class="{-->
    <!--    'fa-check-absolute': !expandToRight,-->
    <!--    'fa-check-absolute-countries': sector === 'countries' && !expandToRight,-->
    <!--    'fa-check-absolute-assignments': sector === 'assignments',-->
    <!--    'fa-check-absolute-bad-num': sector === 'bad_number',-->
    <!--    'fa-check-absolute-sms': sector === 'sms',-->
    <!--    'fa-check-absolute-ni': sector === 'not_interested'-->
    <!--    }"-->
    <!--    -->
    <i class="fas fa-check" style="cursor: pointer;" @click="emitApply"></i>

    <button
      v-if="CheckUserPermission([1, 2, 3, 4, 12])"
      @click="totalModeClick"
      :class="
        clientsTableSelectedMainTab === 'total'
          ? 'btn btn-info'
          : 'btn btn-alert'
      "
      class="total-btn"
    >
      Total Mode
    </button>
    <!--        <label class="switch">-->
    <!--          <input-->
    <!--              -->
    <!--              class="switch-btn"-->
    <!--              type="checkbox" :checked="clientsTableSelectedMainTab === 'total'?'checked':''">-->
    <!--          <span class="slider round"></span>-->
    <!--        </label>-->

    <!--    pagination-->
    <!--    <ul-->
    <!--      class="pagination"-->
    <!--      :class="{-->
    <!--        'pagination-non-ex-deposits': !expandToRight && sector === 'deposits',-->
    <!--        'pagination-non-ex-assignments': !expand && sector === 'assignments',-->
    <!--        'pagination-deposits': expand && sector === 'deposits',-->
    <!--        'pagination-assignments': sector === 'assignments',-->
    <!--        'pagination-non-ex-ld': !expandToRight && sector === 'leads',-->
    <!--        'pagination-ld': sector === 'leads',-->
    <!--        'pagination-campaign': selectedTab === 'campaign',-->
    <!--        'pagination-countries': sector === 'countries',-->
    <!--        'pagination-transfer': sector === 'transfer',-->
    <!--        'pagination-na': sector === 'no_answer',-->
    <!--        'pagination-referral': sector === 'referral',-->
    <!--        'pagination-sms': sector === 'sms',-->
    <!--        'pagination-bn': sector === 'bad_number',-->
    <!--        'pagination-ni': sector === 'not_interested'-->
    <!--      }"-->
    <!--      style="margin: 10px 0"-->
    <!--      v-if="pages > 1"-->
    <!--    >-->
    <!--      &lt;!&ndash;      &ndash;&gt;-->
    <!--      <li class="page-item" v-if="currentPage > 1">-->
    <!--        &lt;!&ndash;        &ndash;&gt;-->
    <!--        <a-->
    <!--          class="page-link"-->
    <!--          :class="{ whitePag: sector === 'bad_number' }"-->
    <!--          style="border: none; padding: 5px 1px;"-->
    <!--          aria-label="Next"-->
    <!--          @click="setCurrentPage(2)"-->
    <!--        >-->
    <!--          <i class="fas fa-chevron-left"></i>-->
    <!--        </a>-->
    <!--      </li>-->
    <!--      <li class="page-item">-->
    <!--        <a-->
    <!--          class="page-link"-->
    <!--          :class="{ whitePag: sector === 'bad_number' }"-->
    <!--          style="padding: 5px 5px; border: none;"-->
    <!--          >{{ currentPage }}</a-->
    <!--        >-->
    <!--      </li>-->
    <!--      <li class="page-item" v-if="currentPage < pages">-->
    <!--        &lt;!&ndash;        &ndash;&gt;-->
    <!--        <a-->
    <!--          class="page-link"-->
    <!--          :class="{ whitePag: sector === 'bad_number' }"-->
    <!--          style="border: none; padding: 5px 1px;"-->
    <!--          aria-label="Next"-->
    <!--          @click="setCurrentPage(1)"-->
    <!--        >-->
    <!--          <i class="fas fa-chevron-right"></i>-->
    <!--        </a>-->
    <!--      </li>-->
    <!--    </ul>-->
    <!--    end pagination-->
    <!--    v-if="sector === 'deposits' && selectedTab === 'brokers'"-->
    <input
      v-if="false"
      type="search"
      class="input-main"
      v-model="amountInput"
      placeholder="Dep Amount"
    />
    <button
      class="btn btn-sm "
      :class="{
        'for-stat-in-camp': selectedTab === 'campaign',
        'for-stat': selectedTab !== 'campaign'
      }"
      v-if="campaignTab"
      @click="emitShowStatistics"
    >
      <span :class="{ 'close-stats': clickedOnStats === 'close' }">{{
        clickedOnStats
      }}</span>
    </button>
    <!--    :class="{-->
    <!--    'fa-sync-container': sector === 'countries' && !expandToRight,-->
    <!--    'fa-sync-absolute-bad-num': sector === 'bad_number',-->
    <!--    'fa-sync-absolute-bad-num': sector === 'not_interested'-->
    <!--    }"-->
    <i
      class="fas fa-sync"
      aria-hidden="true"
      style="cursor: pointer"
      @click="resetMultiselect()"
    ></i>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";

export default {
  name: "BottomMultiSelectBar",
  props: [
    "sector",
    "selectedItems",
    "selectedTab",
    "pages",
    "pageNum",
    "campaignTab",
    "background",
    "expandToRight",
    "expand"
  ],
  computed: {
    ...mapState("clients", ["selectedCalendar", "clientsTableSelectedMainTab"])
  },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      currentPage: 1,
      amountInput: "",
      showStatistics: false,
      clickedOnStats: "stats"
    };
  },
  methods: {
    totalModeClick() {
      if (this.clientsTableSelectedMainTab === "total") {
        this.$store.commit("clients/setClientsTableSelectedMainTab", "clients");
      } else {
        this.$store.commit("clients/setClientsTableSelectedMainTab", "total");
      }
    },
    emitShowStatistics() {
      !this.showStatistics
        ? (this.clickedOnStats = "close")
        : (this.clickedOnStats = "stats");
      this.showStatistics = !this.showStatistics;
      this.$emit("show_statistics", this.showStatistics);
    },
    emitApply() {
      this.$emit("apply");
      this.$emit("close");
    },
    resetMultiselect() {
      this.$emit("reset_multiselect");
    },
    emitPageNumber(page) {
      this.$emit("changePage", page - 1);
    },

    setCurrentPage(operation = 1) {
      if (operation === 1) {
        this.currentPage = this.currentPage + 1;
        this.emitPageNumber(this.currentPage);
      }
      if (operation === 2) {
        this.currentPage = this.currentPage - 1;
        this.emitPageNumber(this.currentPage);
      }
    }
  },
  watch: {
    amountInput() {
      this.$emit("depamount", this.amountInput);
    }
  }
};
</script>

<style scoped>
.main-bottom-multiselect-container-bad_number {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 11px;
  margin-top: 0 !important;
}
.main-bottom-multiselect-container-sms {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 20px;
  margin-top: 0px !important;
}
.main-bottom-multiselect-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 4px;
  margin-top: -7px !important;
}
.main-bottom-multiselect-container-rank {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 1px;
  margin-top: 0 !important;
}
.main-bottom-multiselect-container-without-ex {
  height: 11px;
  display: flex;
  padding-bottom: 11px;
  align-items: center;
  justify-content: space-between;
  /*max-height: 0px;*/
  margin-top: 12px !important;
}
.input-main {
  /*width: 120px;*/
  /*position: relative;*/
  /*display: inline-block;*/
  /*padding: 2px 2px 2px 2px;*/
  /*border: 1px solid white;*/
  /*height: 30px;*/
  /*overflow: hidden;*/
  /*max-width: 97px;*/
  /*text-overflow: ellipsis;*/
  /*font-size: 12px;*/
  /*text-transform: uppercase;*/
  /*-webkit-appearance: none;*/
  /*-moz-appearance: none;*/
  /*-o-appearance: none;*/
  /*box-sizing: border-box;*/
  /*color: black !important;*/
  /*background-color: unset;*/
  /*border-radius: 5px;*/
  position: absolute;
  top: 24px;
  background: none;
  right: 326px;
  /* border-radius: 5px; */
  margin-right: 3px;
  min-width: 120px;
  max-width: 120px;
  text-align: center;
  font-size: 11px;
  border: 2px solid white;
  border-radius: 14px;
  color: white;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 30px;
  max-height: 30px;
}
.page-link {
  color: black !important;
  background-color: unset !important;
}
::placeholder {
  color: white;
}
.fa-check-absolute {
  position: absolute;
  left: 5px;
  bottom: 2px;
}
.fa-check-absolute-assignments {
  position: absolute;
  left: 5px;
  bottom: 2px;
}
.fa-check-absolute-bad-num {
  position: absolute;
  left: 5px;
  bottom: 2px;
  color: white;
}
.fa-check-absolute-ni {
  position: absolute;
  left: 5px;
  bottom: 2px;
  color: white;
}
.fa-check-absolute-sms {
  position: absolute;
  left: 5px;
  bottom: 2px;
}
.fa-check-absolute-countries {
  position: absolute;
  left: 7px;
  bottom: 2px;
}
.fa-sync {
  /*bottom: 2px;*/
  /*position: absolute;*/
  /*right: 2px;*/
}
.fa-sync-container {
  bottom: 2px;
  position: absolute;
  right: 7px;
}
.fa-sync-absolute-bad-num {
  bottom: 2px;
  position: absolute;
  right: 4px;
  color: white;
}
.pagination-non-ex-ld {
  bottom: -16px;
  /* display: inline-block !important; */
  position: absolute;
  left: 204px;
  /* margin: -16px 0 0 202px !important; */
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-ld {
  bottom: -16px;
  /* display: inline-block !important; */
  position: absolute;
  left: 556px;
  /* margin: -16px 0 0 202px !important; */
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-non-ex-deposits {
  bottom: -16px;
  /* display: inline-block !important; */
  position: absolute;
  left: 250px;
  /* margin: -16px 0 0 202px !important; */
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-non-ex-assignments {
  bottom: -17px;
  /* display: inline-block !important; */
  position: absolute;
  left: 289px;
  /* margin: -16px 0 0 202px !important; */
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-deposits {
  bottom: -17px;
  position: absolute;
  left: 280px !important;
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-assignments {
  bottom: -16px;
  /* display: inline-block !important; */
  position: absolute;
  left: 180px !important;
  /* margin: -16px 0 0 202px !important; */
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-location {
  bottom: -16px;
  position: absolute;
  left: 214px !important;
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-campaign {
  bottom: -16px;
  position: absolute;
  left: 214px !important;
  border-radius: 4px !important;
  cursor: pointer;
}

.pagination-countries {
  bottom: -16px;
  position: absolute;
  left: 180px !important;
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-transfer {
  bottom: -16px;
  position: absolute;
  left: 525px !important;
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-referral {
  bottom: -16px;
  position: absolute;
  left: 525px !important;
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-sms {
  bottom: -17px;
  position: absolute;
  left: 180px !important;
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-bn {
  bottom: -14px;
  position: absolute;
  left: 180px !important;
  border-radius: 4px !important;
  cursor: pointer;
  color: white;
}
.pagination-ni {
  bottom: -14px;
  position: absolute;
  left: 180px !important;
  border-radius: 4px !important;
  cursor: pointer;
  color: white !important;
}
.pagination-na {
  bottom: -16px;
  position: absolute;
  left: 525px !important;
  border-radius: 4px !important;
  cursor: pointer;
}
.pagination-sc {
  bottom: -16px;
  position: absolute;
  left: 525px !important;
  border-radius: 4px !important;
  cursor: pointer;
}
.for-stat {
  position: absolute;
  top: 22px;
  left: 217px;
  margin-right: 3px;
  min-width: 112px;
  max-width: 120px;
  text-align: center;
  font-size: 12px;
  border: 2px solid white;
  border-radius: 14px;
  color: white;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 30px;
  max-height: 30px;
  background-color: unset;
  font-family: Montserrat;
}
.for-stat-in-camp {
  position: absolute;
  top: 2px;
  left: 4px;
  font-size: 12px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  /* margin-right: 3px; */
  /* min-width: 112px; */
  /* max-width: 120px; */
  /* text-align: center; */
  /* font-size: 12px; */
  /* color: white; */
  /* -webkit-box-pack: center; */
  /* -ms-flex-pack: center; */
  /* justify-content: center; */
  /* display: -webkit-box; */
  /* display: flex; */
  /* -webkit-box-align: center; */
  /* -ms-flex-align: center; */
  /* align-items: center; */
  /* min-height: 30px; */
  /* max-height: 30px; */
  background-color: unset;
  font-family: Montserrat;
  border-radius: 5px;
  border: 1px solid white;
  color: white;
}
.whitePag {
  color: white !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: -5px;
  bottom: 0px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.switch-btn:checked + .slider {
  background-color: #2196f3;
}

.switch-btn:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

.switch-btn:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.total-btn {
  /*font-size: 10px;*/
  /*height: 20px;*/
  /*display: flex;*/
  /*justify-items: center;*/
  /*align-items: center;*/
  font-size: 11px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: none;
  border: 1px solid;
  color: white;
}
.total-btn:focus {
  outline: none;
}
.close-stats {
  color: red;
}
button:active,
button:focus {
  outline: none !important;
}
i.fas.fa-check,
i.fas.fa-check,
.fas.fa-sync {
  color: white;
}
</style>
